import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { LoaderOptions } from '../interfaces/loader-options';

@Injectable()
export class LoaderService {
  private readonly DEFAULT_MESSAGE: string = 'Por favor espere...';

  private toggle: Subject<LoaderOptions> = new Subject<LoaderOptions>();
  public loaderState = this.toggle.asObservable();

  public show(message: string = this.DEFAULT_MESSAGE): void {
    this.toggle.next({
      message: message,
      toggle: true
    });
  }

  public hide(): void {
    this.toggle.next({
      toggle: false
    });
  }
}
